import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Form = styled.form`
  all: unset;
`;

export const Field = styled.div`
  padding: 32px 40px 33px;
  display: flex;
  align-items: baseline;
  ${({ position }) =>
    position === 'top' &&
    css`
      align-items: flex-start;
    `}
`;

export const InputWrapper = styled.div`
  flex: 75%;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const LabelWrapper = styled.div`
  flex: 25%;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
  span {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: ${Palette.PrimaryGray._500};
    display: flex;
    svg {
      margin-left: 4px;
      cursor: pointer;
    }
  }
`;

export const UploadWrapper = styled.div`
  flex: 75%;
`;

export const Head = styled.h2`
  padding: 32px 40px 0;
  font-weight: 600;
  line-height: 32px;
`;

export const Box = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgba(30, 50, 70, 0.1), 0px 1px 2px rgba(30, 50, 70, 0.06);
`;

export const Container = styled.div`
  width: 65%;
  min-width: 638px;
`;

export const BtnGroup = styled.div`
  display: flex;
  margin: 24px 0 64px;
  gap: 16px;
`;

export const Requirements = styled.span`
  max-width: 156px;
  max-height: 64px;
  color: ${Palette.PrimaryGray._500};
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`;
